import React from 'react';
import { Card, CardContent, Typography, ButtonBase } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';


const Event = ({ eventInfo }) => {
    const history = useNavigate();
    const eventId = eventInfo._id || eventInfo.item_type_id || eventInfo.id;
    const eventTitle = eventInfo.name || eventInfo.title || 'Untitled event';
    const eventCategory = eventInfo.category_label || eventInfo.category || 'Event';
    const eventSummary =
        eventInfo.summary ||
        eventInfo.description ||
        eventInfo.species ||
        eventCategory;
    const eventLocation = eventInfo.locations || eventInfo.location_name || 'Location pending';
    const eventType = eventInfo.event_type || eventCategory;
    const openEvent = () => history(`/events/${encodeURIComponent(String(eventId || ''))}`);

    return (
        <Card raised elevation={6} className="atlas-result-card">
            <ButtonBase onClick={openEvent} className="atlas-card-button">
                <CardContent className="atlas-card-content">
                    <span className="atlas-card-kicker">{eventCategory}</span>
                    <Typography variant="h5" component="h2" className="atlas-card-title">
                        {eventTitle}
                    </Typography>
                    <Typography variant="body2" className="atlas-card-copy">
                        {eventSummary}
                    </Typography>
                    <div className="atlas-detail-list">
                        <span>
                            <strong>Location</strong>
                            {eventLocation}
                        </span>
                        <span>
                            <strong>Type</strong>
                            {eventType}
                        </span>
                    </div>
                    <span className="atlas-card-link">Read event brief</span>
                </CardContent>
            </ButtonBase>
        </Card>
    );
};

export default Event;
